<template>
	<div v-if="isTriggers && actions.length > 0">
		<v-btn
			color="primary"
			outlined
			@click="clickButton"
			rounded
			:fab="fab != null"
		>
			<v-icon>mdi-flash</v-icon>
		</v-btn>
		<drawerAction
			ref="drawerActionRef"
			v-model="open"
			:entity="entity"
			:noSearch="noSearch"
			:title="title"
			:persistent="persistent"
			:data="data"
		></drawerAction>
	</div>
</template>

<script>
	import drawerAction from "@/components/drawers/drawerAction";
	export default {
		props: ["entity", "noSearch", "title", "fab", "persistent", "data"],
		components: { drawerAction },

		data() {
			return {
				open: false,
				isTriggers: false,
				actions: [],
			};
		},
		methods: {
			clickButton() {
				this.open = !this.open;
			},

			async getActions() {
				let res = this.entity
					? await this.$http.get(`action/entity-${this.entity}`)
					: await this.$http.get("action/separate");
				if (res.success) {
					this.actions = res.data;
				}
			},
		},

		async mounted() {
			this.isTriggers = await this.$auth.isTriggers();
			await this.getActions();
		},
	};
</script>

<style></style>
